import { DownloadPdfUpdateButton } from 'components/DownloadPdfUpdateButton';
import Table from 'components/Table';
import { dateToLabel } from 'further-ui/utils';
import { useGetReportsForInvestor } from 'hooks/data/investorReporting/useGetReportsForInvestor';
import { usePagination } from 'further-ui/hooks';

type Props = any; //TODO: define props

const InvestorUpdates: React.FC<Props> = ({ investorId, investorDetail }) => {
  const pagination = usePagination();
  const columns = [
    {
      label: 'Date',
      key: 'submitDate',
      sort: false,
      render: (elm) => dateToLabel(elm?.submitDate),
    },
    {
      label: 'Update title',
      key: 'managerOverViewTitle',
      sort: false,
    },
    {
      label: 'Download',
      key: 'download',
      sort: false,
      render: (elm) => (
        <DownloadPdfUpdateButton
          reportingId={elm._id}
          investorId={investorId}
          filename={`${investorDetail.fullName}-${elm.managerOverViewTitle}.pdf`}
          pdfUrl={elm.reportPdfUrl}
        />
      ),
    },
  ];
  const reports = useGetReportsForInvestor({
    params: {
      investorId,
      page: pagination.page,
      perPage: pagination.rowsPerPage,
      sortKey: 'submitDate',
      sortOrder: 'desc',
    },
  });

  return (
    <Table
      pagination={true}
      columns={columns}
      loading={reports.isFetching}
      tablebody={reports?.data?.investorReports ?? []}
      variant="nohover"
      emptyMessage="This investor has not been included in any investor updates."
      onPageChange={pagination.handleChangePage}
      onRowsPerPageChange={pagination.handleChangeRowsPerPage}
      page={pagination.page}
      rowsPerPage={pagination.rowsPerPage}
      count={reports?.data?.total ?? 0}
    />
  );
};

export default InvestorUpdates;
